var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"redirect-to-qr-code-public-v1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }